export class Environment {
  static getName(): string {
    return process.env.NODE_ENV || 'development';
  }

  static isDevelopment(): boolean {
    return ['development'].indexOf(this.getName().toLowerCase()) >= 0;
  }

  static isProduction(): boolean {
    return ['production'].indexOf(this.getName().toLowerCase()) >= 0;
  }
}
